import React, {useEffect, useState, useCallback, useRef} from 'react'
import {GoogleMap, useLoadScript, Marker} from '@react-google-maps/api'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {useLocation} from 'react-router-dom'
const libraries = ['places'] as any
const mapContainerStyle = {
  width: '100vw',
  height: '100vh',
}

const GoogleMapComponent = ({
  latitude,
  longitude,
  onSelectLocation,
  multiLocations,
  categoryId,
  onVendorIdChange,
}: {
  latitude: any
  longitude: any
  onSelectLocation: any
  multiLocations?: any
  categoryId?: any
  onVendorIdChange? :any
}) => {
  const [selectedPlace, setSelectedPlace] = useState({
    lat: latitude || 41.3113642,
    lng: longitude || 69.28267819999999,
  }) as any

  const markerRef = useRef(null) as any
  const mapRef = useRef(null) as any
  let location = useLocation()
  const [currentLocation, setCurrentLocation] = useState("") as any ;
  const [markers, setMarkers] = useState([])
  

  useEffect(() => {
    if (location.pathname == "/viewmaps") {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setSelectedPlace({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
        }
      );
    }
  }, [location.pathname]);


  useEffect(() => {
    if (multiLocations && multiLocations.length > 0) {
      setMarkers(multiLocations);
      // Zoom the map to the markers
      const bounds = new window.google.maps.LatLngBounds();
      multiLocations.forEach((marker:any) => {
        bounds.extend(marker); // Extend the bounds to include each marker
      });
      if (mapRef.current) {
        mapRef.current.fitBounds(bounds); // Adjust the map to fit the bounds
      }
    }
  }, [multiLocations]);

  
  useEffect(() => {
    if (multiLocations && multiLocations.length > 0) {
      setMarkers(multiLocations)
    }else {
      setMarkers([])
    }
  }, [multiLocations])

  useEffect(() => {
    if (latitude && longitude) {
      const newLocation: any = {lat: latitude, lng: longitude}
      setSelectedPlace(newLocation)
      if (mapRef.current) {
        mapRef.current.panTo(newLocation)
      }
      animateMarker()
    }
  }, [latitude, longitude])

  const {isLoaded, loadError} = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY!,
    libraries,
  })

  const onMapClick = useCallback((event: any) => {
    const newMarker = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    }

    setSelectedPlace(newMarker)
    if (mapRef.current) {
      mapRef.current.panTo(newMarker)
    }
    animateMarker()
    reverseGeocode(newMarker, newMarker)
  }, [])

  const onMarkerDragEnd = useCallback((event: any) => {
    const newPosition = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    }

    setSelectedPlace(newPosition)
    if (mapRef.current) {
      mapRef.current.panTo(newPosition)
    }
    animateMarker()
    reverseGeocode(newPosition, newPosition)
  }, [])

  const animateMarker = () => {
    if (markerRef.current) {
      markerRef.current.setAnimation(window.google.maps.Animation.BOUNCE)
      setTimeout(() => {
        markerRef.current.setAnimation(null)
      }, 200) // Bounce animation duration
    }
  }

  const extractLocationDetails = (result: any, exactCoordinates: any) => {
    const addressComponents = result.address_components
    const locationDetails = {
      location: result.formatted_address,
      state: getAddressComponent(addressComponents, 'administrative_area_level_1'),
      city: getAddressComponent(addressComponents, 'locality'),
      country: getAddressComponent(addressComponents, 'country'),
      latitude: exactCoordinates.lat,
      longitude: exactCoordinates.lng,
    }
    return locationDetails
  }

  const reverseGeocode = async (marker: any, exactCoordinates: any) => {
    const geocoder = new window.google.maps.Geocoder()
    geocoder.geocode({location: marker}, (results: any, status) => {
      if (status === 'OK') {
        let locationDetails: any = {
          location: 'Unknown location',
          state: '',
          city: '',
          country: '',
          latitude: exactCoordinates.lat,
          longitude: exactCoordinates.lng,
          plusCode: '',
        }

        for (let i = 0; i < results.length; i++) {
          if (results[i].plus_code && results[i].plus_code.global_code) {
            locationDetails = extractLocationDetails(results[i], exactCoordinates)
            locationDetails.plusCode = results[i].plus_code.global_code
            break
          } else if (i === 0) {
            // Use the first result if no plus code is found
            locationDetails = extractLocationDetails(results[i], exactCoordinates)
          }
        }
        onSelectLocation(locationDetails)
      } else {
        onSelectLocation({
          location: 'Unknown location',
          state: '',
          city: '',
          country: '',
          latitude: exactCoordinates.lat,
          longitude: exactCoordinates.lng,
        })
      }
    })
  }

  const getAddressComponent = (addressComponents: any, type: any) => {
    const component = addressComponents.find((component: any) => component.types.includes(type))
    return component ? component.long_name : ''
  }

  if (loadError) {
    return <div>Error loading maps</div>
  }

  if (!isLoaded) {
    return <div>Loading maps</div>
  }

  let locator = ''

  if (categoryId == 1) {
    locator = toAbsoluteUrl('/media/mappoints/accommodationlocator.png')
  } else if (categoryId == 3) {
    locator = toAbsoluteUrl('/media/mappoints/cafelocator.png')
  } else if (categoryId == 4) {
    locator = toAbsoluteUrl('/media/mappoints/spacerentallocator.png')
  } else if (categoryId == 5) {
    locator = toAbsoluteUrl('/media/mappoints/tourpackagelocator.png')
  } else if (categoryId == 7) {
    locator = toAbsoluteUrl('/media/mappoints/carrentallocator.png')
  }
  const customMarkerIcon = {
    url: locator, // Replace with your image URL
    scaledSize: new window.google.maps.Size(50, 50), // Adjust the size of the marker (width, height)
  }

  const handleMarkerClick = (vendorId : any) => {
    onVendorIdChange(vendorId); 

  };
  

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      zoom={10}
      center={selectedPlace}
      onClick={onMapClick}
      mapContainerClassName='w-100 h-400px shadow-sm rounded-4'
      onLoad={(map: any) => (mapRef.current = map)}
    >
      { markers.length !=0  ?  markers.map((marker:any, index) => {
        return (
          <Marker
            key={index}
            position={marker}
            icon={customMarkerIcon}
            onLoad={(marker) => {
              if (!markerRef.current) {
                markerRef.current = marker 
              }
            }}
            onClick={() => handleMarkerClick(marker.vendorId)} 

          />
        )
      }) : ""}

      <Marker
        position={selectedPlace}
        draggable={true}
        onDragEnd={onMarkerDragEnd}
        onLoad={(marker) => (markerRef.current = marker)}
      />
    </GoogleMap>
  )
}

export default GoogleMapComponent
